import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { useEffect, useRef } from 'react';
import { AUTH_EVENTS, eventBus } from './utils/eventBus';
import { useMutation, useQueryClient } from 'react-query';
import api from './services/api/v2';

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);

export const useFCMToken = async () => {
  const queryClient = useQueryClient();
  const { mutate: registerFcmToken } = useMutation({
    mutationFn: async (fcmToken: string) => {
      await api.patch(`/token/fcm`, {
        fcmToken,
      });
    },
    onError: (error) => {
      console.log('failed to register FCM token ::: \n\n', error);
    },
  });

  const updateFCMToken = useRef(async () => {
    await Notification.requestPermission();
    try {
      const messaging = getMessaging(firebaseApp);
      const fcmToken = await getToken(messaging, {
        vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
      });
      if (fcmToken) {
        registerFcmToken(fcmToken);
        onMessage(messaging, (payload) => {
          // foreground 상태에서의 알림 처리
          queryClient.invalidateQueries(['alarmcenter', 'list']);
        });
      }
    } catch (err) {
      console.log('failed to retrieve FCM token ::: \n\n', err);
    }
  });

  // Broadcast Channel을 통한 백그라운드 알림 처리
  useEffect(() => {
    const notificationChannel = new BroadcastChannel('notification-updates');

    const handleBackgroundNotification = (event) => {
      if (event.data.type === 'REFRESH_ALARMCENTER') {
        queryClient.invalidateQueries(['alarmcenter', 'list']);
      }
    };

    notificationChannel.addEventListener(
      'message',
      handleBackgroundNotification
    );

    return () => {
      notificationChannel.removeEventListener(
        'message',
        handleBackgroundNotification
      );
      notificationChannel.close();
    };
  }, [queryClient]);

  useEffect(() => {
    const subscriptions = [AUTH_EVENTS.USER_LOGGED_IN].map((eventType) =>
      eventBus.subscribe(eventType, updateFCMToken.current)
    );
    updateFCMToken.current();
    return () => {
      subscriptions.forEach((unsubscribe) => unsubscribe());
    };
  }, []);
};

export const FCMTokenManager = () => {
  useFCMToken();
  return null;
};

export const messageHandler = (e) => {
  if (e.origin !== location.origin) return;
};
